import { render, staticRenderFns } from "./GifPlayer.vue?vue&type=template&id=1bcacf6e&scoped=true"
import script from "./GifPlayer.vue?vue&type=script&lang=js"
export * from "./GifPlayer.vue?vue&type=script&lang=js"
import style0 from "./GifPlayer.vue?vue&type=style&index=0&id=1bcacf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcacf6e",
  null
  
)

export default component.exports